import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Attach the active workspace (agency switcher) to every request. Backend falls back to
// the caller's default workspace when the header is absent.
api.interceptors.request.use((config) => {
  const ws = localStorage.getItem("hdg_ws");
  if (ws) {
    config.headers = config.headers || {};
    config.headers["X-Workspace-Id"] = ws;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    const path = window.location.pathname;
    if (e?.response?.status === 401 && path.startsWith("/app")) {
      window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export function imageSrc(url) {
  if (!url) return "";
  return url.startsWith("http") ? url : `${BACKEND_URL}${url}`;
}

export function errMsg(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d && typeof d === "object" && d.message) return d.message;
  return e?.message || fallback;
}

// Returns the plan-limit detail object when a request was blocked (HTTP 402), else null.
export function limitInfo(e) {
  const d = e?.response?.data?.detail;
  if (e?.response?.status === 402 && d && typeof d === "object" && d.code === "limit_reached") return d;
  return null;
}

export default api;
